import { PageHero } from "../components/site/PageHero";
import { About } from "../components/site/About";
import { LicenseBanner } from "../components/site/Trust";
import { CTABand } from "../components/site/CTABand";

export default function AboutPage() {
  return (
    <>
      <PageHero
        eyebrow="About F&C Air Conditioning"
        title="Dependable comfort, built on expertise."
        subtitle="A licensed Florida Class A HVAC contractor serving residential and commercial customers with honest, professional service."
      />
      <About />
      <LicenseBanner />
      <CTABand />
    </>
  );
}
